export enum AnnualAccountingDocumentCount {
	Range1 = '5000',
	Range2 = '10000',
	Range3 = '50000',
	Range4 = '100000',
	Range5 = '100001'
}

